module.exports = __webpack_public_path__ + "assets/img/9897e9fb6b842f179910134e20a7a9e9.webp";